import api from '@/api/axios';

export default {
  namespaced: true,
  state: () => ({
    messages: [],
    isLoading: false,
    error: null,
    sessionId: null,
    sessions: [], // 채팅 세션 목록
  }),
  mutations: {
    ADD_MESSAGE(state, message) {
      state.messages.push(message);
    },
    SET_MESSAGES(state, messages) {
      state.messages = messages;
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_SESSION_ID(state, sessionId) {
      state.sessionId = sessionId;
    },
    SET_SESSIONS(state, sessions) {
      state.sessions = sessions;
    },
    SET_SESSION(state, session) {
      state.session = session;
    },
    CLEAR_MESSAGES(state) {
      state.messages = [];
    },
    REMOVE_SESSION(state, sessionId) {
      state.sessions = state.sessions.filter(session => session.id !== sessionId);
    },
  },
  actions: {
    async createChatSession({ commit }, payload) {
      commit('SET_LOADING', true);
      try {
        console.log("Creating chat session with payload:", payload);
        const response = await api.post('/api/v1/chat/sessions', payload);
        commit('SET_SESSION_ID', response.data.id);
        return response.data;
      } catch (error) {
        if (error.response && error.response.status === 422) {
          console.error("422 Validation Error:", error.response.data);
        }
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async loadChatSession({ commit }, sessionId) {
      commit('SET_LOADING', true);
      try {
        const response = await api.get(`/api/v1/chat/sessions/${sessionId}/messages`);
        
        // 메시지 순서 정렬 (created_at 기준)
        const sortedMessages = response.data.sort((a, b) => 
          new Date(a.created_at) - new Date(b.created_at)
        );

        commit('SET_MESSAGES', sortedMessages);
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async sendMessage({ commit, state }, payload) {
      commit('SET_LOADING', true);
      try {
        // Handle payload as either string or object with content
        const content = typeof payload === 'string' ? payload : payload.content;
        const crawlingJobIds = typeof payload === 'object' ? payload.crawlingJobIds : [];
        const fileIds = typeof payload === 'object' ? payload.fileIds : [];
        let assistantContent = '';
        console.log("sdsdsds") 
        // 프로젝트, 파일 모두 없는 경우 체크 로직
        if (
          (!Array.isArray(crawlingJobIds) || crawlingJobIds.length === 0) &&
          (!Array.isArray(fileIds) || fileIds.length === 0)
        ) {
          assistantContent = '선택된 프로젝트와 파일이 없습니다. 하나 이상 선택 또는 업로드해주세요.';

          const userMessage = {
            role: 'user',
            content,
            created_at: new Date().toISOString()
          };

          commit('ADD_MESSAGE', userMessage);

          const assistantMessage = {
            role: 'assistant',
            content: assistantContent,
            created_at: new Date().toISOString()
          };
          commit('ADD_MESSAGE', assistantMessage);

          return;
        }
        
        const userMessage = {
          role: 'user',
          content,
          created_at: new Date().toISOString()
        };
        commit('ADD_MESSAGE', userMessage);

        // Updated request body to include crawlingJobIds
        const response = await api.post(`/api/v1/chat/chat?session_id=${state.sessionId}`, {
          content,
          crawlingJobIds: crawlingJobIds,
          fileID: fileIds,
          apiType: "openAi" // Adding apiType as required in your spec
        });

        console.log('API Response:', response.data);

        

        // 서버가 200을 반환했지만 success가 false인 경우
        if (response.data?.success === false) {
          assistantContent = response.data.Response || '에러: Response가 비어있습니다.';
        }
        // Response가 공란인 경우
        else if (!response.data?.Response) {
          assistantContent = '일반적인 에러';
        }
        // 정상적인 응답
        else {
          // Check if the response contains chart data
          if (response.data.chartData) {
            // If it has chart data, use the entire response object
            assistantContent = response.data;
          } else {
            assistantContent = response.data;
          }
        }

        const assistantMessage = {
          role: 'assistant',
          content: assistantContent,
          created_at: new Date().toISOString()
        };
        commit('ADD_MESSAGE', assistantMessage);

      } catch (error) {
        // 500 에러
        if (error.response?.status === 500) {
          const assistantMessage = {
            role: 'assistant',
            content: '500에러의 내용 출력',
            created_at: new Date().toISOString()
          };
          commit('ADD_MESSAGE', assistantMessage);
        } else {
          // 기타 에러 처리
          const assistantMessage = {
            role: 'assistant',
            content: error.response?.data?.message || '에러가 발생했습니다.',
            created_at: new Date().toISOString()
          };
          commit('ADD_MESSAGE', assistantMessage);
        }
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async initializeChat({ dispatch, commit, state }, { selectedJobs, sessionId, projectIds }) {
      commit('SET_LOADING', true);
      console.log('initializeChat', selectedJobs, sessionId);
      try {
        if (sessionId) {
          // 기존 세션 불러오기
          commit('SET_SESSION_ID', sessionId);
          await dispatch('loadChatSession', sessionId);
        } else {
          if (selectedJobs && selectedJobs.length > 0 && projectIds && projectIds.length > 0) {
            const crawlingJobIds = selectedJobs.map(job => job.id);
            const session = await dispatch('createChatSession', {
              title: 'New Chat Session',
              crawling_job_ids: crawlingJobIds,
              project_ids: projectIds,
            });
            commit('SET_SESSION_ID', session.id);
          } else {
            throw new Error('No selected jobs or projects provided for new chat session.');
          }
        }
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    // async createCrawlingJobs({ commit }, payload) {
    //   commit('SET_LOADING', true);
    //   try {
    //     const response = await api.post('/api/crawling_jobs', payload);
    //     return response.data;
    //   } catch (error) {
    //     commit('SET_ERROR', error);
    //     throw error;
    //   } finally {
    //     commit('SET_LOADING', false);
    //   }
    // },
    async fetchChatSessions({ commit }) {
      commit('SET_LOADING', true);
      try {
        const response = await api.get('/api/v1/chat/sessions');
        commit('SET_SESSIONS', response.data);
      } catch (error) {
        commit('SET_ERROR', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async getSession({ commit, state }, sessionId) {
      commit('SET_LOADING', true);
      try {
        const response = await api.get(`/api/v1/chat/sessions/${sessionId}`);
        commit('SET_SESSION', response.data);
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async deleteAllMessages({ commit, state }) {
      commit('SET_LOADING', true);
      try {
        await api.delete(`/api/v1/chat/sessions/${state.sessionId}/messages`);
        commit('CLEAR_MESSAGES');
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async deleteChatSession({ commit }, sessionId) {
      commit('SET_LOADING', true);
      try {
        await api.delete(`/api/v1/chat/sessions/${sessionId}`);
        commit('REMOVE_SESSION', sessionId);
        return { success: true, message: '채팅이 성공적으로 삭제되었습니다' };
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
  getters: {
    allMessages: (state) => state.messages,
    isLoading: (state) => state.isLoading,
    error: (state) => state.error,
    sessionId: (state) => state.sessionId,
  },
};